// Lightweight Google Analytics 4 wrapper.
// Reads GA measurement ID from REACT_APP_GA_ID. No-op when missing.

const GA_ID = process.env.REACT_APP_GA_ID;
let initialized = false;

export function initGA() {
  if (initialized || !GA_ID || typeof window === "undefined") return;
  initialized = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, {
    anonymize_ip: true,
    send_page_view: true,
  });
}

export function trackEvent(name, params = {}) {
  if (!GA_ID || typeof window === "undefined" || typeof window.gtag !== "function") return;
  try { window.gtag("event", name, params); } catch {}
}

export function trackPurchase({ transaction_id, value = 50, currency = "EUR", items }) {
  trackEvent("purchase", {
    transaction_id,
    value,
    currency,
    items: items || [{ item_id: "booking_deposit", item_name: "Booking Deposit", price: value, quantity: 1 }],
  });
}
